import { clientEnv } from '@/shared/config/env';
import { requestJson } from '@/shared/request/http-client';
import type { BootstrapResponse } from './types';

export const fetchBootstrap = (signal?: AbortSignal) =>
  requestJson<BootstrapResponse>(
    `/v1/app/bootstrap?siteId=${encodeURIComponent(clientEnv.siteId)}`,
    {
      method: 'GET',
      signal,
    },
  );
